import React from 'react';

import { tax_id_types } from 'lib/constants/constants';

import Button from 'components/shared/Button/Button';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Modal from 'components/shared/Modal/Modal';
import Allowed from 'components/shared/Permissions/Allowed';

import BillingProviderForm from '../lib/BillingProviderForm';

const CreateUpdateBillingProviderForm = ({
  formik,
  isLoading,
  open,
  type,
  handleClose,
  states,
  loadedMembers
}) => {
  const customSelectStyle = {
    control: () => ({
      height: 40,
      display: 'flex',
      padding: '0px 6px',
      fontSize: 14,
      backgroundColor: '#f8f8f8',
      border: '1px solid #dcdcdc',
      borderRadius: '0.5rem'
    }),
    placeholder: (provided) => {
      return {
        ...provided,
        color: '#afafaf'
      };
    },
    singleValue: (provided) => {
      return {
        ...provided,
        fontWeight: 500
      };
    },
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 })
  };

  const handleSelectState = (state) => {
    formik.setFieldValue('bill_state', state?.value);
  };

  const customModalTitle = (type) => {
    if (type == 'create') {
      return 'Create Billing provider';
    }
    if (type == 'update') {
      return 'Update Billing provider';
    }
  };

  return (
    <>
      <Modal
        className="w-full max-w-[800px]"
        handleOpen={open}
        handleClose={() => handleClose()}
        title={customModalTitle(type)}
        footer={
          <div className="flex items-center gap-3">
            <Button
              text="Cancel"
              color="neutral"
              style="outlined"
              size="small"
              onClick={() => handleClose()}
            />
            <Allowed requiredPermissions="billing.create">
              <Button
                isLoading={isLoading}
                text={customModalTitle(type)}
                onClick={() => formik.submitForm()}
                size="small"
              />
            </Allowed>
          </div>
        }>
        <BillingProviderForm
          formik={formik}
          tax_id_types={tax_id_types}
          handleSelectState={handleSelectState}
          states={states}
          customSelectStyle={customSelectStyle}
          loadedMembers={loadedMembers}
        />
      </Modal>
    </>
  );
};

export default withErrorBoundary(CreateUpdateBillingProviderForm);
